export default __webpack_public_path__ + "static/media/img4.49c57301.jpg";